import * as Yup from 'yup';

// Reglas comunes
const commonSchema = {
  date_from: Yup.date()
    .min(new Date(), 'La fecha desde no puede ser anterior a hoy')
    .required('Fecha desde requerida'),
  date_to: Yup.date()
    .min(
      Yup.ref('date_from'),
      'La fecha hasta no puede ser anterior a la fecha desde'
    )
    .required('Fecha hasta requerida'),
  first_name: Yup.string().required('Nombre requerido'),
  last_name: Yup.string().required('Apellido requerido'),
  whatsapp: Yup.string()
    .matches(/^\d+$/, 'El WhatsApp debe contener solo números')
    .min(8, 'El WhatsApp debe tener al menos 8 dígitos')
    .max(15, 'El WhatsApp no puede superar 15 dígitos')
    .required('Whatsapp requerido'),
  email: Yup.string()
    .email('Formato inválido de email')
    .required('Email requerido'),
  minors_ages: Yup.array().of(
    Yup.object().shape({
      age: Yup.number()
        .typeError('Edad debe ser un número')
        .min(0, 'Edad mínima 0')
        .required('Edad requerida'),
      quantity: Yup.number()
        .typeError('Cantidad debe ser un número')
        .min(0, 'Cantidad mínima 0')
        .required('Cantidad requerida'),
    })
  ),
  plate_link: Yup.string().url('Link de placa inválido'),
};

// Esquema general (con punto de venta)
export const validationSchema = Yup.object().shape({
  ...commonSchema,
  id_entity: Yup.mixed().required('Punto de venta requerido'),
});

// Esquema CCO
export const validationSchemaCCO = Yup.object().shape({
  ...commonSchema,
});
